<app-form-wrapper [title]="'Message ' + (messagesService.savedMessages.length + 1)">
  <form [formGroup]="messagesForm" (submit)="$event.preventDefault()">
    <div class="cf__body">
      <p class="cf__lead">
        @if (messagesService.savedMessages.length) {
          Write another message for this campaign, or continue with the
          {{ messagesService.savedMessages.length === 1 ? "one" : messagesService.savedMessages.length }} you have.
        } @else {
          Write the first message. A campaign can send several, each at its own times.
        }
      </p>

      <div class="cf__row">
        <!-- sender id -->
        <input-field label="Sender ID" hint="The name recipients see the SMS come from.">
          <bk-select
            formControlName="senderId"
            [options]="senderIDs"
            valueKey="senderId"
            variant="sender"
            noun="sender ID"
            placeholder="Choose a sender ID"
            emptyText="No sender IDs available"
            (valueChange)="messagesService.messages.senderId = $event || ''"
          />
        </input-field>

        <!-- message template -->
        <input-field label="Start from a template" hint="Optional. Replaces the message text below.">
          <bk-select
            formControlName="template"
            [options]="templates"
            valueKey="id"
            labelKey="name"
            detailKey="content"
            variant="template"
            noun="template"
            placeholder="Choose a template"
            emptyText="No templates yet"
            (valueChange)="handleSelectTemplate($event)"
          />
        </input-field>
      </div>

      <!-- message subject -->
      <input-field label="Subject" hint="For your reports. Recipients don’t see it.">
        <input
          type="text"
          id="cf-subject"
          class="input-style"
          placeholder="For example, Fee reminder, first notice"
          autocomplete="off"
          formControlName="subject"
          (change)="messagesService.messages.subject = messagesForm.get('subject')!.value"
        />
      </input-field>

      <!-- Message body -->
      <div>
        <input-field label="Message">
          <div class="cf__compose">
            <textarea
              name="body"
              #messageTextarea
              id="body"
              rows="6"
              class="input-style"
              placeholder="Type the SMS your recipients will get"
              formControlName="body"
              (change)="messagesService.messages.body = messagesForm.get('body')!.value"
            ></textarea>
            <message-attribute-menu (select)="appendAttribute(messageTextarea, $event)"></message-attribute-menu>
          </div>

          <!-- added contact-attribute chips -->
          <message-attribute-chips
            [message]="messagesForm.controls['body'].value"
            (remove)="removeAttribute($event)"
          ></message-attribute-chips>
        </input-field>

        <!-- what the copy costs -->
        <div class="cf__meter">
          <span>
            @if (parts.estimated) {
              About
            }
            <strong>{{ parts.length }}</strong>
            @if (parts.parts <= 1) {
              of {{ parts.perPart }} characters
            } @else {
              characters
            }
            · <strong>{{ parts.parts || 0 }}</strong> {{ parts.parts === 1 ? "part" : "parts" }}
          </span>
          @if (parts.parts && audience.count !== null) {
            <span>
              × {{ formatCount(audience.count) }} {{ audience.count === 1 ? "recipient" : "recipients" }} ≈
              <strong>{{ formatCount(parts.parts * audience.count) }}</strong> SMS each time it sends
            </span>
          }
          @if (unicodeNote) {
            <p class="cf__meter-note">{{ unicodeNote }}</p>
          }
        </div>
        <p class="bk-sr-only" aria-live="polite">{{ partsAnnouncement }}</p>
        <p class="cf__hint">
          Personalize with <strong>Insert contact attribute</strong> (the &#123; &#125; button beside the message): it
          adds a contact field such as <code>{{ "{{firstName}}" }}</code>, filled in for each recipient.
        </p>
      </div>

      <!-- Add message -->
      <div class="cf__add-row">
        <button
          type="button"
          class="bk-btn bk-btn--ghost"
          [disabled]="!messagesForm.valid"
          (click)="handleSaveMessage()"
        >
          <span class="bk-sym" aria-hidden="true">add</span>
          Add message to campaign
        </button>
        @if (!messagesForm.valid && messagesForm.dirty) {
          <p class="cf__foot-note">{{ missingText }}</p>
        }
      </div>
    </div>

    <!-- footer -->
    <div class="cf__foot">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="this.cancelCampaignService.openCancelModal()">
        Cancel
      </button>
      <div class="cf__foot-end">
        @if (invalid) {
          <p class="cf__foot-note">Add at least one message to continue.</p>
        } @else if (hasUnsavedDraft) {
          <p class="cf__foot-note">The message above isn’t added yet.</p>
        }
        <button type="button" class="bk-btn bk-btn--ghost" (click)="goBack()">Back</button>
        <button type="button" class="bk-btn bk-btn--primary" [disabled]="invalid" (click)="handleSubmit()">
          Continue to schedule
          <span class="bk-sym cf__go" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  </form>
</app-form-wrapper>
